<template>
    <div>
      <common-dialog
        ref="dialog"
        width="1200px"    
        :show-save-button="$permission.canEdit()" 
        unit="条款"
        edit-title
        id-key="RecordId"
        :data="data"
        form-label-width="105px"
        :form-rules="rules"
        :save-func="api.save"
        @create-opened="onCreateOpened"
        @edit-opened="onEditOpened"
        close-on-saved
        :before-save="onBeforeSave"
        @closed="onClosed"
        @close-saved="$emit('close-saved')"
      >
      <!--width是整个窗口的宽度-->
        <template slot="form">
          <el-row>
            <el-col :span="isMB?24:12">  <!--这句用于判断手机和电脑的不同显示，如果是手机则24表示全屏，如果是电脑，则12表示占一半-->
              <el-form-item label="帮助标题" prop="HelpTitle">
                <el-input v-model="data.HelpTitle" placeholder="请填写帮助标题" clearable></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="isMB?24:12">
              
            </el-col>
          </el-row>

          <el-row>
           
            <el-col :span="24"> 
             <!--多行文本框，无论手机和电脑都占满，所有都是24-->
            <!--   <el-form-item label="条款内容" prop="TermContent">
                <el-input v-model="data.TermContent" type="textarea" rows="12" placeholder="请填写条款内容" clearable></el-input>
            默认普通文本编辑框不用加type，type="textarea"为多行文本框
            </el-form-item>-->
            <el-form-item :label="isMB?'':'帮助内容'" :label-width="isMB?'0':''" prop="HelpDetail">
              <el-divider v-if="isMB">帮助内容</el-divider>
              <editor ref="editor" v-model="data.HelpDetail" height="400px"></editor>
              <el-input v-model="data.HelpDetail" v-show="false"></el-input>
            </el-form-item>

            </el-col>
            
            <el-col :span="isMB?24:12">
              
            </el-col>


          </el-row>


         
          <el-row>
          <el-col :span="isMB?24:12">
            <el-form-item label="序号" prop="OrderId">
              <el-input-number v-model="data.OrderId" :min="0" />
            </el-form-item>
          </el-col>
          <el-col :span="isMB?24:12">
            <el-form-item label="状态" prop="State">
              <el-radio-group v-model="data.State">
                <el-radio :label="1">启用</el-radio>
                <el-radio :label="0">停用</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        </template>
        <template #footer v-if="!$permission.canEdit()">
          <el-button @click="close">关 闭</el-button>
        </template>
      </common-dialog>
    </div>
  </template>
  <script>
  import editDialogMixin from "@/mixins/editDialog";
  import commonDialog from "@/components/common/dialog";
  import editor from '@/components/common/editor.vue';
  
  export default {
    mixins: [editDialogMixin],
    components: {
      commonDialog,
      editor,
    },
    data() {
      return {
        data: {               //每次刷新页面后各编辑框的初始值，例如某个字段如果不清空，继承上一次编辑的内容，则不赋予初值就好
          RecordId: 0,
          HelpTitle: "",
          HelpDetail: "",
          
          OrderId: 0,
          State: 1,
        },
        api: require("@/api/sy/help").default,
        isMB: this.$store.state.isMB,
        rules: {
          HelpTitle: [{ required: true, message: "帮助标题不能为空" }],   //TermName这个名称就必须和上面各类录入框的prop属性值一致，就是控制同名的录入框的必填
          HelpDetail: [{ required: true, message: "帮助内容不能为空" }],
        
        },
       
      };
    },
    methods: {
      onCreateOpened(row) {
        this.api.getMaxOrderId().then(res => {
          if(res.Code==0) this.data.OrderId = res.Data;
        })
      },
      onEditOpened(row) {
        
      },
      onBeforeSave() {
        
      },
      onClosed() {
  
      },
    },
  };
  </script>